import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteNewsAndEventsRequest, deleteNewsAndEventsRequestError, deleteNewsAndEventsRequestSuccess } from '../../slices/NewsAndEvents/DeleteNewsAndEventsSlice';

export const DeleteNewsAndEventsAPI = (id) => {
    const url = `${endpoints.deletNewsAndEvents}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteNewsAndEventsRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteNewsAndEventsRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteNewsAndEventsRequestError(_error));
        }
    };
};
